// extracted by mini-css-extract-plugin
module.exports = {"Footer":"_271LmZuRiEsC4aa44BUxtU","Content":"_1nbGDp9WiDNJImMCjqGA_S","Logo":"_3vwqPQeffR7eZqGjromIz5"};